import e,{createContext as r,useContext as l}from"react";const o=r({onClose:()=>{},show:!1,triggerRef:null}),t=({children:r,values:l})=>e.createElement(o.Provider,{value:l},r),a=()=>l(o);export{t as default,a as useHeaderLocationProvider};
